'use client';

import classNames from 'classnames';
import { PrismicNextLink } from '@prismicio/next';
import { Menu, MenuButton, MenuItems, MenuItem } from '@headlessui/react';

// Types
import { NavigationMenuDropdown } from '@/types/navigation/siteNavigation';

// Services
import { onDropdownHeaderOpen } from '@preventx/prismic-services/src/services/display/dropdown';

type NavigationDropdownProps = {
  dropdown: NavigationMenuDropdown;
};

export const NavigationDropdown = ({ dropdown }: NavigationDropdownProps) => (
  <Menu as="div" className="dropdown">
    {({ open }) => {
      if (open) {
        onDropdownHeaderOpen();
      }

      return (
        <>
          <MenuButton className="dropdown__control site-head__link">
            {dropdown.label}
          </MenuButton>

          <MenuItems
            as="ul"
            anchor="bottom start"
            className={classNames({
              'dropdown__panel active stack-nav m-0': open,
            })}
          >
            {dropdown.items.map(({ id, link }) => (
              <MenuItem key={`navigation-dropdown-visible-${id}`}>
                <PrismicNextLink field={link} />
              </MenuItem>
            ))}
          </MenuItems>

          {!open && (
            <ul aria-hidden={true} className="hidden">
              {dropdown.items.map(({ id, link }) => (
                <li key={`navigation-dropdown-hidden-${id}`}>
                  <PrismicNextLink field={link} />
                </li>
              ))}
            </ul>
          )}
        </>
      );
    }}
  </Menu>
);
